import useLoadingIndicator from "../../../../component/Loader/Loader";
import MainCard from "../../../../component/MainCard/MainCard";
import ProjectDetailsTab from "../../../../component/ProjectDetailsTab/ProjectDetailsTab";
import { Strings } from "../../../../constant/Strings";
import ProfileTabs from "../../../../component/Tabs/Tabs";
import { useEffect, useState } from "react";
import PoHistory from "../../ProjectRepository/ProjectRepositoryFunctions/PoHistory";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as actions from "../../../../Redux/Actions";

const ResourcePOHistory = () => {
  const { resourceName } = Strings;
  const { id, projectId } = useParams();
  const dispatch = useDispatch();
  const [poHistoryData, setPoHistoryData] = useState([]);
  const [resourceNameVal, setResourceNameVal] = useState("");
  useEffect(() => {
    showLoadingIndicator();
    dispatch(
      actions.getResourcePODetailsAction(id, (res: any) => {
        if (res?.length > 0) {
          setPoHistoryData(res);
          setResourceNameVal(res?.[0]?.resourceName?.split("-")[0]);
        }
        hideLoadingIndicator();
      })
    );
  }, [id]);
  const {
    showLoadingIndicator,
    hideLoadingIndicator,
    loadingComponent,
  } = useLoadingIndicator();
  const [poHistoryTab, setPoHistoryTab] = useState(true);

  const handlePoHistory = () => {};

  return (
    <>
      {loadingComponent()}
      <MainCard>
        <ProjectDetailsTab
          navigateTo={`/resource-adding/${projectId}`}
          tabHeading={resourceName}
          headingValue={resourceNameVal}
        />
        <div className="tabs-container">
          <ProfileTabs
            title="PO History"
            onClick={handlePoHistory}
            active={poHistoryTab}
          />
        </div>
        <div className="profile-container">
          {poHistoryTab && <PoHistory poHistoryData={poHistoryData} />}
        </div>
      </MainCard>
    </>
  );
};
export default ResourcePOHistory;
